export default "__VITE_PUBLIC_ASSET__e22dade9__"